export default __webpack_public_path__ + "static/hodler-271eed2d1202384fedb5e98f8eb16c19.png";